import { Injectable } from '@angular/core';
import {UserMeta} from "../models/types";
import {S3FileUploaderService} from "./s3FileUploader";

@Injectable({
  providedIn: 'root'
})
export class MetaServiceService {

  constructor(private s3: S3FileUploaderService) { }

  async run_uploads(username: UserMeta) {

    let users_str   = localStorage.getItem("FACE_UIL");
    let users = JSON.parse(users_str) as UserMeta[];
    let install_str = localStorage.getItem("FACE_IM");
    let installs = JSON.parse(install_str) as any;
    let did: string;
    if(installs) {
      did = installs['unique_installation_id'];
      if(!installs['sent']) {
        this.s3.addUploadObject({
          file_name: `${installs.unique_installation_id}.json`,
          type: "TEXT",
          upload_dir: "INSTALLS",
          modality: "FACE",
          ts: installs.timestamp,
          bucket: "image-identy-web",
          data: JSON.stringify(installs)
        })
        installs['sent'] = true;
      }
      localStorage.setItem("FACE_IM", JSON.stringify(installs));
    }

    if(users) {
      for (let i = 0; i < users.length; i++) {
        const user = users[i];
        if(!user.sent) {
          user.unique_user_id = `${user.username}${did}`;
          this.s3.addUploadObject({
            file_name: `${user.unique_user_id}.json`,
            type: "TEXT",
            upload_dir: "USERS",
            modality: "FACE",
            ts: user.creation_date,
            bucket: "image-identy-web",
            data: JSON.stringify(user)
          });
          users[i].sent = true;
        }
      }
      localStorage.setItem("FACE_UIL", JSON.stringify(users));
    }
    username.unique_user_id = `${username.username}${did}`;
    await this.s3.upload_frames(username);
  }
}
